/**
 * MenuContent is a immediate child of Menu component sibling to MenuLabel.
 * Clicking MenuLabel toggles visibility of MenuContent.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import { MenuItem } from '..';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

import css from './MenuContent.module.css';

const MenuContent = (props) => {
  const {
    arrowPosition,
    children,
    className,
    contentClassName,
    contentRef,
    isOpen,
    rootClassName,
    style,
    id,
    labelId,
  } = props;

  const { popoverBackgroundColor } = useDefaultShopStyles();

  const rootClass = rootClassName || css.root;
  const openClasses = isOpen ? css.isOpen : css.isClosed;
  const classes = classNames(rootClass, className, openClasses);
  const contentClasses = classNames(contentClassName || css.content);

  const arrowPositionStyle =
    arrowPosition && style.right != null
      ? { position: 'absolute', right: arrowPosition, top: 0 }
      : { position: 'absolute', left: arrowPosition, top: 0 };

  const arrow = arrowPosition ? (
    <div style={arrowPositionStyle}>
      <Box bgcolor={popoverBackgroundColor || 'white'}>
        <Box
          className={classNames(css.arrowBase, css.arrowBelow)}
          style={{ borderBottomColor: popoverBackgroundColor || 'white' }}
        />
        <Box
          className={classNames(css.arrowBase, css.arrowTop)}
          style={{ borderBottomColor: popoverBackgroundColor || 'white' }}
        />
      </Box>
    </div>
  ) : null;

  React.Children.forEach(children, (child) => {
    if (!child) {
      return;
    }
    if (child.type !== MenuItem) {
      throw new Error('All children of MenuContent must be MenuItems.');
    }
    if (child.key == null) {
      throw new Error('All children of MenuContent must have a "key" prop.');
    }
  });

  return (
    <Box
      className={classes}
      ref={contentRef}
      style={style}
      bgcolor={popoverBackgroundColor || 'white'}
    >
      {arrow}
      <ul id={id} className={contentClasses} role="menu" aria-labelledby={labelId}>
        {children}
      </ul>
    </Box>
  );
};

MenuContent.defaultProps = {
  arrowPosition: null,
  className: null,
  contentClassName: null,
  contentRef: null,
  isOpen: false,
  rootClassName: '',
  style: null,
  id: null,
  labelId: null,
};

const { bool, func, node, number, object, string } = PropTypes;

MenuContent.propTypes = {
  arrowPosition: number,
  children: node.isRequired,
  className: string,
  contentClassName: string,
  contentRef: func,
  isOpen: bool,
  rootClassName: string,
  style: object,
  id: string,
  labelId: string,
};

export default MenuContent;
